import { Button, Form, Input, Space, Row, Col } from 'antd'
import { useState } from 'react'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import { isValidArray } from '../../../../../sprints/components/testReport/testCases/forms/helper'

const { TextArea } = Input

function ExportReportForm(props) {
    const {
        setOpen = () => {},
        onExport = () => {},
        exporting = false,
        stickyActions = true, // set true if you want sticky footer actions
    } = props

    const [form] = Form.useForm()
    const { id } = useParams()

    const handleSubmit = async (values) => {
        const finalAttachments = isValidArray(values?.attachments)
            ? values?.attachments?.filter(
                  (item) => item.name.trim() !== '' && item.url.trim() !== ''
              )
            : []
        const payload = {
            reportId: id,
            reportName: values?.name || '',
            reportImage: '',
            notes: values?.note || '',
            attachments: finalAttachments,
        }
        onExport(payload)
    }

    return (
        <div
            style={{
                maxWidth: 900,
                width: '100%',
                margin: '0 auto',
                background: '#fff',
                // borderRadius: 8,
            }}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{
                    name: '',
                    note: '',
                    attachments: [{ name: '', url: '' }],
                }}
            >
                {/* Report Name */}
                <Form.Item
                    label="Report Name"
                    name="name" // <-- fixed to match payload
                    rules={[
                        { required: true, message: 'Report name is required' },
                        { max: 120, message: 'Max 120 characters' },
                    ]}
                    style={{ marginBottom: 16 }}
                >
                    <Input placeholder="Enter title" />
                </Form.Item>

                {/* Notes */}
                <Form.Item
                    label="Note"
                    name="note"
                    style={{ marginBottom: 16 }}
                >
                    <TextArea rows={4} placeholder="Enter note" />
                </Form.Item>

                <p>Attachments</p>

                {/* Attachments (Dynamic) */}
                <Form.List name="attachments">
                    {(fields, { add, remove }) => (
                        <Space
                            direction="vertical"
                            style={{ width: '100%' }}
                            size={12}
                        >
                            {fields.map(({ key, name, ...restField }, idx) => (
                                <div key={key}>
                                    <Row gutter={[12, 8]} align="top">
                                        <Col xs={24} md={8}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'name']}
                                                label="Name"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message:
                                                            'Please enter a name',
                                                    },
                                                    {
                                                        max: 100,
                                                        message:
                                                            'Max 100 characters',
                                                    },
                                                ]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input placeholder="Name" />
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={14}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'url']}
                                                label="URL"
                                                rules={[
                                                    {
                                                        required: false,
                                                        message:
                                                            'Please enter a URL',
                                                    },
                                                    {
                                                        type: 'url',
                                                        message:
                                                            'Please enter a valid URL (include http/https)',
                                                    },
                                                ]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input placeholder="https://example.com" />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            xs={24}
                                            md={2}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'flex-end',
                                                justifyContent: 'flex-start',
                                                gap: 8,
                                                marginTop: 30,
                                            }}
                                        >
                                            {idx > 0 && (
                                                <Button
                                                    title="Remove"
                                                    danger
                                                    type="text"
                                                    icon={
                                                        <MinusCircleOutlined />
                                                    }
                                                    onClick={() => remove(name)}
                                                    aria-label="Remove row"
                                                ></Button>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            ))}

                            <Button
                                type="link"
                                size="small"
                                onClick={() => add({ name: '', url: '' })}
                                icon={<PlusOutlined />}
                                style={{ padding: 0 }}
                            >
                                Add more
                            </Button>
                        </Space>
                    )}
                </Form.List>

                {/* Actions */}
                <div
                    style={{
                        position: stickyActions ? 'sticky' : 'static',
                        bottom: stickyActions ? 0 : 'auto',
                        background: stickyActions ? '#fff' : 'transparent',
                        padding: stickyActions ? '12px 0 0' : 0,
                        marginTop: 20,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 10,
                        flexWrap: 'wrap',
                    }}
                >
                    <Button
                        type="default"
                        htmlType="button"
                        onClick={() => setOpen(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="default"
                        htmlType="submit"
                        loading={exporting}
                    >
                        Export
                    </Button>
                </div>
            </Form>
        </div>
    )
}

export default ExportReportForm
